/**
 * Put this file inside the /source/js/vendor/ folder and run 'gulp jsvendor'
 * Ensure SearchWP query only runs when done typing, not on every character being typed to reduce server stress.
 */
document.addEventListener('facetwp-loaded', () => {
	let timeout;
	const wait = 1500;  // time in ms
	const searchInputs = document.querySelectorAll('.facetwp-type-search');

	searchInputs.forEach((input) => {
		// Check if facet has auto refresh enabled, otherwise continue loop (return is used in JS)
		if ( FWP.settings[input.dataset.name].auto_refresh && FWP.settings[input.dataset.name].auto_refresh !== 'yes' ) {
			return;
		}
		const inputField = input.querySelector('input');

		// On keyup of search inputs, temp disable auto refresh
		inputField.addEventListener('keyup', () => {
			FWP.auto_refresh = false;

			if ( inputField.value ) {
				clearTimeout(timeout);

				// Start timeout to create time for user to type and manually run FacetWP refresh
				timeout = setTimeout(() => {
					FWP.auto_refresh = true;
					FWP.refresh();
				}, wait);
			}
		});
	});
});
